import React from 'react';
import { Typography } from '@mui/material';
import GRRResultsSection from '../GRRResultsSection';
import CapabilityImpactResults from './CapabilityImpactResults';
import AttributeAgreementResults from './AttributeAgreementResults';
import AttributeAnalyticResults from './AttributeAnalyticResults';

// ---------------------------------------------------------------------------
// MsaResults — dispatches a computed /api/msa `results` payload to the correct
// per-module renderer. Type 3 reuses the shared GRR results layout field-for-
// field (its engine output mirrors type2GRR: anovaTable / varianceComponents /
// grrMetrics / studyDesign / interpretation).
// ---------------------------------------------------------------------------

function MsaResults({ studyType, results, meta }) {
    if (!results) return null;

    switch (studyType) {
        case 'type3':
            return <GRRResultsSection results={results} />;
        case 'capabilityImpact':
            return <CapabilityImpactResults results={results} meta={meta} />;
        case 'attribute':
            return <AttributeAgreementResults results={results} meta={meta} />;
        case 'attributeAnalytic':
            return <AttributeAnalyticResults results={results} meta={meta} />;
        default:
            return (
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)' }}>
                    No results renderer available for study type “{studyType}”.
                </Typography>
            );
    }
}

export default MsaResults;
